import React from 'react';
import { X } from 'lucide-react';

const ImageModal = ({ imageUrl, onClose, altText = 'Image' }) => {
  // Fermer le modal en cliquant sur le backdrop
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Fermer avec la touche Échap
  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    
    // Empêcher le scroll du body quand le modal est ouvert
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [onClose]);

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm p-4"
      onClick={handleBackdropClick}
    >
      {/* Bouton de fermeture */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 p-2 bg-white/10 hover:bg-white/20 rounded-full transition-colors z-10"
        title="Fermer"
      >
        <X className="w-6 h-6 text-white" />
      </button>

      {/* Image en plein écran */}
      <div className="relative max-w-4xl max-h-[90vh] w-full">
        <img
          src={imageUrl}
          alt={altText}
          className="w-full h-full object-contain rounded-lg"
        />
      </div>
    </div>
  );
};

export default ImageModal;
